export const STUDENT_CODE = {
  key: "student_code",
  message: "Student Id already exists",
}
